import { render, staticRenderFns } from "./TreatmentCategories.vue?vue&type=template&id=74037b4d&"
import script from "./TreatmentCategories.vue?vue&type=script&lang=js&"
export * from "./TreatmentCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports